import React from 'react'
import { translate } from '../../../utils/translate'
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';

function NotFound(props) {
    return (
        <>
            <div className="py-5 text-center bg-transparent">
                <Row className='justify-content-center align-items-center'>
                    <Col lg={2} md={2} sm={4} xs={4}>
                        <img src={require('../../../images/noData.svg').default} className="img-fluid" alt="no-data" />
                    </Col>
                </Row>
                
                <span className="d-block text-grey-9 mt-4">
                    {translate(props.lang, "Oops! No data found...")}
                </span>
            </div>
        </>
    )
}
const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(NotFound);